import React from 'react'


import { marketPlaceParam } from "../../assets/Js/paramName";
import { urlCopyToClipboard } from "../../assets/Js/urlCopyToClipboard";
import { getPlainToken } from "../../assets/Js/tokenHandler";
import { useHistory } from "react-router-dom";
import Stars from "../Stars/Stars";
import DisplayPicture from "../DisplayPicture/DisplayPicture";

export default function NewMarketplaceTrackCard({
    id,
    name,
    price,
    type,
    image,
    joinPassword,
    trialPeriodDays,
    isTrackJoinned,
    description,
}) {
    const history = useHistory();

    let search = window.location.search;
    let queryParams = `?${marketPlaceParam}=${id}`;
    let _link;
  
    if (getPlainToken()) {
      _link = `/trackjoiningpage${queryParams}`;
    } else {
      _link = `/registrationform/athleteaccount${queryParams}`;
    }
  
    if (search) {
      search = search.replace("?", "&");
      _link = _link + search;
    }
  
    const redirectToJoinTrack = () => {
      history.push(_link);
    };
    const copyToClipboard = () => {
      let url = window.location;
      urlCopyToClipboard(url.host + _link);
    };
  
    const _trialPeriodDays = trialPeriodDays
      ? trialPeriodDays > 1
        ? `${trialPeriodDays} - Days Free Trial`
        : `${trialPeriodDays} - Day Free Trial`
      : "";

  return (
    <div className="listing row no-gutters">
      <DisplayPicture image={image} className="img col-lg-4" showGymAvatar={true}/>
      <div className="info col-lg-8">
        <h2>
          {name}
          {price !== 0 && <span></span>}
        </h2>
        <p>
        ${price} / month
        </p>
        <div className="subinfo">
          <div className="stars-info mr-2">
            <Stars/>
          </div>
        </div>
        <div className="subinfo">
         <p>{description}</p> 
         <p>{_trialPeriodDays}</p>
        </div>
        <hr />
        <div className="d-flex pricing-info">
          <span>
          Get shareable link
            <i
              onClick={copyToClipboard}
              className="mdi mdi-link-variant pointerCursor shareableLink"
            ></i>
          </span>
          <button
            type="submit"
            class="secondaryBtn brand-btn"
            onClick={redirectToJoinTrack}
          >
           Join Track
          </button>
        </div>
      </div>
    </div>
  );
}

